import React, { useState } from "react";
import { Card, Col, Row, Spinner, Table } from "react-bootstrap";
import { FaSearch } from "react-icons/fa";
import { MdOutlineOilBarrel, MdOutlineQuestionMark, MdOutlineSolarPower } from "react-icons/md";
import { SlEnergy } from "react-icons/sl";
import { TbFlame } from "react-icons/tb";
import { useNavigate } from "react-router-dom";
import PrivateApi from "../../services/PrivateApiService";


/**
 * HvAnlageCard
 * 
 * displays basic infomation about HV Anlagen
 * 
 * used in: Support new ticket
 * 
 * @param {anlage} props object Anlage
 * @param {noElvs} props bool to display or not elvs
 * 
 * @returns GUI
 */
const HvAnlageCard = (props) => {

    const API = new PrivateApi();
    const navigate = useNavigate();
    const anlage = props.anlage;
    let headerBg = "";
    const [elvsLoading, setElvsLoading] = useState(false);
    const [elvsDisplayed, setElvsDisplayed] = useState(false);
    const [activeTab, setActiveTab] = useState('active-elvs');
    const [elvs, setElvs] = useState();

    if (anlage) {
        if (anlage.x_studio_field_3eKe0 === "Strom") headerBg = '#a2c13f';
        else if (anlage.x_studio_field_3eKe0 === "Gas") headerBg = '#3fbfbf';
        else if (anlage.x_studio_field_3eKe0 === "Oil") headerBg = '#a2c13f';
        else if (anlage.x_studio_field_3eKe0 === "Strom-Einspeisung") headerBg = '#ffc107';
        else headerBg = '#3d3d3d'
    }

    const loadElvs = (e) => {
        if (props.noElvs !== true) {
            e.preventDefault();
            setElvsLoading(true);
            API.get_ElvsAnlage(anlage.id)
                .then(res => {
                    let data = res.data;
                    setElvs(data);
                    setElvsLoading(false);
                    setElvsDisplayed(true);
                })
                .catch(err => {
                    setElvsLoading(false);
                })
        }
    }

    const navigateToElv = (elv_id) => {
        navigate(`/hw/dashboard/energieliefervertraege/${elv_id}`);
    }


    // GUI
    return (

        <Card className="mt-3 shadow-lg rounded">
            <Card.Header className="text-start text-white" style={{ background: headerBg }}>
                <div className="border border-2 rounded-circle"
                    style={{ width: "54px", color: "white", paddingLeft: "10px", paddingTop: "10px", paddingRight: "10px", paddingBottom: "10px", display: "inline-block", float: "left" }}
                >
                    {
                        anlage.x_studio_field_3eKe0 === 'Strom' ?
                            <SlEnergy size={30} />
                            :
                            anlage.x_studio_field_3eKe0 === 'Gas' ?
                                <TbFlame size={30} />
                                :
                                anlage.x_studio_field_3eKe0 === 'Oil' ?
                                    <MdOutlineOilBarrel size={30} />
                                    :
                                    anlage.x_studio_field_3eKe0 === 'Strom-Einspeisung' ?
                                        <MdOutlineSolarPower size={30} />
                                        :
                                        <MdOutlineQuestionMark size={30} />
                    }
                </div>
                <div style={{ display: "inline-block", float: "left", paddingTop: "16px", marginLeft: "10px" }} className="hide-on-small">
                    Anlage: {anlage.x_studio_field_3eKe0}
                </div>
                <div style={{ display: "inline-block", float: "right", paddingTop: "5px" }}>
                    <span style={{ fontSize: "30px", fontWeight: "300" }}>{anlage.x_studio_field_mWMGR}</span>
                </div>
                <div className="hide-on-small" style={{ display: "inline-block", float: "right", paddingTop: "16px" }}>
                    Anlagenummer ENERGO: &nbsp;
                </div>
            </Card.Header>
            <Card.Body className="text-start">
                <Row className="align-items-center mt-3">
                    <p>Anlagenadresse &nbsp; <small className="text-muted">{anlage.x_adresse_kompakt}</small></p>
                    {anlage.x_studio_field_6T9W2 !== 'False' ?
                        <p>Top: &nbsp; <small className="text-muted">{anlage.x_studio_field_6T9W2}</small></p>
                        :
                        null
                    }
                    <p>Anlagenverwendung: &nbsp; <small className="text-muted">
                        {anlage.x_anlagenverwendung !== undefined && anlage.x_anlagenverwendung !== "False" ?
                            anlage.x_anlagenverwendung : "unbekannt"
                        }
                    </small></p>
                    <Row className="mt-3">
                        <Col className={anlage.x_zaehlpunktnummer_02 ? 'border-right' : null} xs="12" md={anlage.x_zaehlpunktnummer_02 ? "6" : "12"} xl={anlage.x_zaehlpunktnummer_02 ? "6" : "12"}>
                            {anlage.x_zaehlpunktnummer_02 ?
                                <p className="text-center" style={{ color: headerBg }}>Zählpunkt 1</p>
                                :
                                null
                            }
                            <p>Zählernummer &nbsp; <small className="text-muted">{anlage.x_zaehlernummer_01}</small></p>
                            <p>Zählpunktnummer &nbsp; <small className="text-muted">{anlage.x_zaehlpunktnummer_01}</small></p>
                            {anlage.x_lastprofil_01 !== "False" ? (
                                <p>Lastprofil &nbsp; <small className="text-muted">{anlage.x_lastprofil_01}</small></p>
                            ) : null}
                        </Col>
                        {anlage.x_zaehlpunktnummer_02 ?
                            <Col xs="12" md="6" xl="6">
                                <p style={{ color: headerBg }} className="text-center">Zählpunkt 2</p>
                                <p>Zählernummer &nbsp; <small className="text-muted">{anlage.x_zaehlernummer_02}</small></p>
                                <p>Zählpunktnummer &nbsp; <small className="text-muted">{anlage.x_zaehlpunktnummer_02}</small></p>
                                {anlage.x_lastprofil_02 !== "False" ? (
                                    <p>Lastprofil &nbsp; <small className="text-muted">{anlage.x_lastprofil_02}</small></p>
                                ) : null}
                            </Col>
                            :
                            null
                        }
                    </Row>
                </Row>
                <Row className="mt-5 mb-3">
                    <Col xs="12" className="text-center" hidden={elvsDisplayed || elvsLoading}>
                        <a hidden={props.noElvs} onClick={e => loadElvs(e)} href={`/energieliefervertraege/anlage/${anlage.id}`} style={{ color: headerBg, textDecoration: "none" }}>
                            Energielieferverträge anzeigen
                        </a>
                    </Col>
                    <Col xs="12" className="text-center" hidden={!elvsLoading}>
                        <Spinner animation="grow" style={{ color: headerBg }} /> &nbsp;
                        <Spinner animation="grow" style={{ color: headerBg }} /> &nbsp;
                        <Spinner animation="grow" style={{ color: headerBg }} />
                    </Col>
                    <Col xs="12" hidden={elvsLoading || elvs === undefined || elvsDisplayed === false}>
                        <ul className="nav nav-tabs nav-fill" id="myTab" role="tablist">
                            <li className="nav-item" role="presentation">
                                <button
                                    onClick={() => setActiveTab('active-elvs')}
                                    style={{ background: activeTab === 'active-elvs' ? headerBg : null, color: activeTab === 'active-elvs' ? 'white' : 'black' }}
                                    className={`nav-link ${activeTab === 'active-elvs' ? 'active' : null}`}
                                    id="active-elvs-tab"
                                    data-bs-toggle="tab" data-bs-target="#active-elvs"
                                    type="button" role="tab" aria-controls="active-elvs"
                                    aria-selected="true">Aktuell</button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button
                                    onClick={() => setActiveTab('inactive-elvs')}
                                    style={{ background: activeTab === 'inactive-elvs' ? headerBg : null, color: activeTab === 'inactive-elvs' ? 'white' : 'black' }}
                                    className={`nav-link ${activeTab === 'inactive-elvs' ? 'active' : null}`}
                                    id="inactive-elvs-tab"
                                    data-bs-toggle="tab" data-bs-target="#inactive-elvs"
                                    type="button" role="tab" aria-controls="inactive-elvs"
                                    aria-selected="false">Ältere</button>
                            </li>
                        </ul>
                        <div className="tab-content" id="elvsContent">
                            {elvs !== undefined && elvs.length > 0 ?
                                activeTab === 'active-elvs' ?
                                    <Table hover responsive className="mt-2">
                                        <tbody>
                                            {elvs.filter(el => new Date(el.x_datum_vertragsende) >= new Date() || el.x_datum_vertragsende === 'False').length === 0 ?
                                                <tr>
                                                    <td className="text-center">
                                                        <p>Es sind keine aktuellen Energielieferverträge für diese Anlage vorhanden</p>
                                                    </td>
                                                </tr>
                                                :
                                                elvs.map(el => (
                                                    new Date(el.x_datum_vertragsende) > new Date() || el.x_datum_vertragsende === 'False' ? (
                                                        <tr onClick={() => navigateToElv(el.id)} key={el.id}>
                                                            <td>
                                                                <p style={{ color: headerBg, fontWeight: 700 }}>{el.x_energieprodukt_id[1]}</p>
                                                                <p>Belieferungsbeginn &nbsp; <small className="text-muted">{el.x_belbeg === 'False' ? 'TBA' : new Date(el.x_belbeg).toLocaleDateString('DE-de')}</small></p>
                                                                <p>Vertragsende &nbsp; <small className="text-muted">{el.x_datum_vertragsende === 'False' ? 'offenes Vertragsende' : new Date(el.x_datum_vertragsende).toLocaleDateString('DE-de')}</small></p>
                                                            </td>
                                                            <td className="td-vertical-center">
                                                                <FaSearch size={20} color={headerBg} />
                                                            </td>
                                                        </tr>
                                                    ) : null
                                                ))
                                            }
                                        </tbody>
                                    </Table>
                                    :
                                    <Table hover responsive className="mt-2">
                                        <tbody>
                                            {elvs.filter(el => new Date(el.x_datum_vertragsende) < new Date()).length === 0 ?
                                                <tr>
                                                    <td>
                                                        <p>Es sind keine älteren Energielieferverträge für diese Anlage vorhanden</p>
                                                    </td>
                                                </tr>
                                                :
                                                elvs.map(el => (
                                                    new Date(el.x_datum_vertragsende) < new Date() ?
                                                        <tr onClick={() => navigateToElv(el.id)} key={el.id}>
                                                            <td>
                                                                <p style={{ color: headerBg, fontWeight: 700 }}>{el.x_energieprodukt_id[1]}</p>
                                                                <p>Belieferungsbeginn &nbsp; <small className="text-muted">{el.x_belbeg === 'False' ? 'TBA' : new Date(el.x_belbeg).toLocaleDateString('de-DE')}</small></p>
                                                                <p>Vertragsende &nbsp; <small className="text-muted">{el.x_datum_vertragsende === 'False' ? 'offenes Vertragsende' : new Date(el.x_datum_vertragsende).toLocaleDateString('de-DE')}</small></p>
                                                            </td>
                                                            <td className="td-vertical-center">
                                                                <FaSearch size={20} color={headerBg} />
                                                            </td>
                                                        </tr>
                                                        : null
                                                ))}
                                        </tbody>
                                    </Table>
                                : null}
                        </div>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    )
}

export default HvAnlageCard;